import { Logo } from "./Logo";
import { NAV_LINKS, CAPABILITY_DOC_URL } from "../lib/siteData";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="border-t border-white/10 bg-forest py-14">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid gap-10 lg:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <Logo dark />
            <p className="mt-5 max-w-sm font-body text-sm leading-relaxed text-white/60">
              A multi-partner platform delivering sustainable, smart, and resilient assets through one
              coordinated framework.
            </p>
          </div>
          <div>
            <div className="font-body text-xs font-semibold uppercase tracking-widest text-lime-bright">
              Navigate
            </div>
            <ul className="mt-4 space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.href.replace("#", "")}`}
                    className="font-body text-sm text-white/60 transition-colors hover:text-white"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <div className="font-body text-xs font-semibold uppercase tracking-widest text-lime-bright">
              Resources
            </div>
            <ul className="mt-4 space-y-2.5">
              <li>
                <a
                  href={CAPABILITY_DOC_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-capability-link"
                  className="font-body text-sm text-white/60 transition-colors hover:text-white"
                >
                  Capability Document
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  data-testid="footer-contact-link"
                  className="font-body text-sm text-white/60 transition-colors hover:text-white"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 sm:flex-row sm:items-center">
          <p className="font-body text-xs text-white/50">
            © {new Date().getFullYear()} Frontiers Infra Sustainability Consortium. All rights reserved.
          </p>
          <p className="font-body text-xs text-white/50">
            Building Sustainable, Smart & Resilient Assets for Tomorrow.
          </p>
        </div>
      </div>
    </footer>
  );
};
